import { Directive } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
    selector: '[appEmptyInputValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EmptyInputValidatorDirective,
            multi: true,
        },
    ],
    standalone: false
})
export class EmptyInputValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return checkEmpty(control.value);
  }
}

export function EmptyInputValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return checkEmpty(control.value);
  };
}

function checkEmpty(value: string) {
  return value?.trim().length < 1 ? { emptyString: 'Input is empty' } : null;
}
